module.exports = __webpack_public_path__ + "static/media/icon-star.4219c345.svg";